import { schoolTokenAxios } from "../axios";

const SCHOOL_REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;

let complaint_url = `${SCHOOL_REPORTING_BASE}/complaint`;

// =============== COMPLAINT MANAGEMENT ===============

// Get complaints with optional filters (complaintDocId, from, to, complaintNumber)
export const getComplaint = (params) => {
  return schoolTokenAxios.get(`${complaint_url}/getComplaint`, {
    params: params,
  });
};

// Add new complaint by staff
export const addNewComplaintByStaff = (data) => {
  return schoolTokenAxios.post(`${complaint_url}/addNewComplaintByStaff`, data);
};

// Delete complaint by ID
export const deleteComplaint = (complaintDocId) => {
  return schoolTokenAxios.delete(
    `${complaint_url}/deleteComplaint/${complaintDocId}`
  );
};

// Update assignee for complaint
export const updateAssignee = (data) => {
  return schoolTokenAxios.put(`${complaint_url}/updateAssignee`, data);
};

// Resolve complaint
export const resolveComplaint = (data) => {
  return schoolTokenAxios.put(`${complaint_url}/resolveComplaint`, data);
};

// =============== MESSAGE THREADS ===============

// Add new message to complaint thread
export const addNewMessage = (data) => {
  return schoolTokenAxios.post(`${complaint_url}/addNewMessage`, data);
};

// Update message by ID
export const updateMessage = (messageDocId, data) => {
  return schoolTokenAxios.put(
    `${complaint_url}/updateMessage/${messageDocId}`,
    data
  );
};

// Get messages for a complaint
export const getMessages = (complaintDocId) => {
  return schoolTokenAxios.get(`${complaint_url}/getMessages/${complaintDocId}`);
};

// Delete message by ID
export const deleteMessage = (messageDocId) => {
  return schoolTokenAxios.delete(
    `${complaint_url}/deleteMessage/${messageDocId}`
  );
};

